module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-03.e1a510c1.png";